import React from "react";
import "./ModuleStepper.scss";

const ModuleStepper = ({
  currentStep,
  steps,
  children,
  leftControls,
  className = "",
}) => {
  const getActiveColor = (index) => {
    const stepNumber = index + 1;
    if (currentStep > stepNumber) {
      return "selected_green_tick"; // Step is completed
    } else if (currentStep === stepNumber) {
      return "selected_gray_tick"; // Step is currently active
    } else {
      return "selected_dark_gray_tick"; // Future step
    }
  };

  const getCircleClass = (index) => {
    const stepNumber = index + 1;
    if (currentStep > stepNumber) {
      return "circle-active"; // Step is completed
    } else if (currentStep === stepNumber) {
      return "circle-current"; // Step is currently active
    } else {
      return "circle-default"; // Future step
    }
  };

  return (
    <>
      <div className={`module-stepper-container ${className}`}>
        {leftControls ? (
          <div className="left-controls-box">{leftControls}</div>
        ) : (
          <div className="empty-box"></div>
        )}
        <div className="stepper">
          {steps.map((label, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;

            return (
              <React.Fragment key={index}>
                <div className="step">
                  <div style={{color: "#1E1E1E", fontWeight: 600}} className={`step-label ${isActive ? "active" : ""}`}>
                    {label}
                  </div>
                  <div className={`circle ${getCircleClass(index)}`}></div>
                </div>
                {index < steps.length - 1 && (
                  <div className={`line ${getActiveColor(index)}`}></div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        {children && <article className="preview-box">{children}</article>}
      </div>
    </>
  );
};

export default ModuleStepper;
